import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54696296&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54696296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54696296",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Header/index.vue').default,AdmSlotPreload: require('/Users/daiyu/Desktop/work-code/bantervideo/components/AdmSlotPreload.vue').default,ContentItemCard: require('/Users/daiyu/Desktop/work-code/bantervideo/components/ContentItemCard.vue').default,AdmSlot: require('/Users/daiyu/Desktop/work-code/bantervideo/components/AdmSlot.vue').default,InfiniteScrollList: require('/Users/daiyu/Desktop/work-code/bantervideo/components/InfiniteScrollList.vue').default,Footer: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Footer/index.vue').default,BackTop: require('/Users/daiyu/Desktop/work-code/bantervideo/components/BackTop/index.vue').default,FixedBottom: require('/Users/daiyu/Desktop/work-code/bantervideo/components/FixedBottom.vue').default})
